<template>
  <button class="btn" :class="className">
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: 'BaseButton',
  props: {
    className: {
      type: String,
    },
  },
};
</script>

<style lang="scss">
.btn {
  background-color: $company-color;
  border-radius: 0.5rem;
  color: white;
  border: none;
  width: 9rem;
  height: 3.8rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 1rem;
  cursor: pointer;
  transition: all 0.3s;

  .icon {
    fill: white;
    width: 1.8rem;
    margin-left: 0.7rem;
  }

  &--center {
    justify-content: center;
  }

  &:hover {
    background-color: darken($company-color, 10%);
  }
}
</style>
